import Vue from 'vue';
import VueRouter from 'vue-router';
// 路由模块引入
import user from './user';
import application from './application';
import signDocument from './signDocument';
import { getStore, getStoreSession } from '@/utils/utils';
import { Toast } from 'vant';

Vue.use(VueRouter);
Vue.use(Toast);

const routes = [
  {
    path: '/',
    name: 'index',
    meta: {
      title: '中国贸促会平台',
    },
    component: () => import('@/views/index/Index.vue'),
  },
  {
    path: '/index',
    name: 'index',
    meta: {
      title: '中国贸促会平台',
    },
    component: () => import('@/views/index/Index.vue'),
  },
  // 放置模块路由
  ...user,
  ...application,
  ...signDocument
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach(async (to, from, next) => {
  window.document.title = to.meta.title === undefined ? '中国贸促会平台' : to.meta.title;
  if (to.matched.some((record) => record.meta.requireAuth)) {
    if (getStoreSession('haslogin') && getStore('token') && getStoreSession('haslogin') == 'yes') {
      next();
    } else {
      Toast.fail('您当前未登录，请先登录！');
      setTimeout(() => {
        next({
          path: '/user/login',
        });
      }, 1000);
    }
  } else {
    next();
  }
});
export default router;
